import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../shared/app.constants';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
var ShiftService = /** @class */ (function () {
    function ShiftService(http, appConstants, auth) {
        this.http = http;
        this.appConstants = appConstants;
        this.auth = auth;
    }
    ShiftService.prototype.getPopupShifts = function (startDate, endDate) {
        var url = environment.apiBase + ("popup/shifts?startDate=" + startDate + "&endDate=" + endDate);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    ShiftService.prototype.getShiftDetails = function (id) {
        var url = environment.apiBase + ("popup/shifts/" + id);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    ShiftService.prototype.createPopupShift = function (body) {
        var url = environment.apiBase + "popup/shifts";
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.post(url, body, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    ShiftService.prototype.deletePopupShift = function (id) {
        var url = environment.apiBase + "popup/shifts/" + id;
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.delete(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return ShiftService;
}());
export { ShiftService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/shift.service.ts.pre-build-optimizer.js